<div class="view-container">
  <ng-container *ngIf="!selectedRenderedOutput; else showPanorama">
    <situ-browse
      [allowRenderCancelation]="false"
      [allowOpenSituViewOrFacade]="false"
      (selectedRenderedOutput)="onSelectedRenderedOutput($event)"
    ></situ-browse>
  </ng-container>

  
  <ng-template #showPanorama>
    <button class="back-button" type="submit" mat-flat-button color="primary" (click)="selectedRenderedOutput = undefined" matTooltip="Search">
      <mat-icon>arrow_back</mat-icon> Back
    </button>

    <situ-view-readonly
      [artifactId]="selectedRenderedOutput.artifactId"
      [editorMode]="true"
    ></situ-view-readonly>

  </ng-template>
</div>